import { amountSeparatorFormatter } from "@/utils/utils";

/**
 * @description: 格式化时间 将时间戳转为标准格式
 * @description: 示例{{ startTime | dataFormat("yyyy-MM-dd hh:mm:ss") }}
 * @params value 时间
 * @params fmt 转化格式
 * @return {*}
 */
export const dataFormat = (value, fmt) => {
  if (!value) return value;
  let getDate = new Date(value);
  let o = {
    "M+": getDate.getMonth() + 1,
    "d+": getDate.getDate(),
    "h+": getDate.getHours(),
    "m+": getDate.getMinutes(),
    "s+": getDate.getSeconds(),
    "q+": Math.floor((getDate.getMonth() + 3) / 3),
    S: getDate.getMilliseconds(),
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (getDate.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  for (let k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
    }
  }
  return fmt;
};

/**
 * @description: 金额格式化
 * @description: 示例{{ amount | amountFormatter("88838849030.04") }}
 * @param {金额} value
 * @returns
 */
export const amountFormatter = (value) => {
  return amountSeparatorFormatter(value);
};

/**
 * 超出固定字符长度显示...   len规定的字节长度
 * @param {*} value
 * @param {*} len
 * @returns
 */
export const characterLengthLimit = (value, len) => {
  return value && value.length > len
    ? value.slice(0, len - 1).concat("...")
    : value;
};
